import { DataTableCol } from "../../../components/tables/types";

export const ConversionsDataGridCols: DataTableCol[] = [
  {
    title: "Date",
    control: "createdAt",
    sortable: true,
    canShowColumn: true,
  },
  {
    title: "Name",
    control: "name",
    sortable: true,
    canShowColumn: true,
  },
  {
    title: "College Name",
    control: "collegeName",
    sortable: true,
    canShowColumn: true,
  },
  {
    title: "Phone",
    control: "contactNo",
    sortable: true,
    canShowColumn: true,
  },
  {
    title: "Branch",
    control: "department",
    sortable: true,
    canShowColumn: true,
  },

  {
    title: "ADD",
    control: "AccessBdiButton",
    sortable: false,
    canShowColumn: true,
  },
  {
    title: "Select Value",
    control: "selectMessageValue",
    canShowColumn: true,
  },
  {
    title: "Actions",
    control: "both",
    sortable: false,
    isEdit: false,
    isDelete: false,
    canShowColumn: false,
  },
];
